import i18n from '@/i18n/i18n'
import { PhoneSurveyAnswerService } from '@/services/admin/PhoneSurveyAnswerService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  surveys: [],
  survey: null,
  answer: [],
  administrativeReminderSurvey: []
}

export const mutations = {
  SET_SURVEYS(state, surveys) {
    state.surveys = surveys
  },
  SET_SURVEY(state, survey) {
    state.survey = survey
  },
  UPDATE_ANSWER(state, params) {
    state.answer = params.response
  },
  SET_ADMINISTRATIVE_REMINDER_SURVEY(state, surveys) {
    state.administrativeReminderSurvey = surveys
  }
}

export const actions = {
  getSurveys({ commit, dispatch }, orderId) {
    return new Promise((resolve, reject) => {
      PhoneSurveyAnswerService.getSurveys(orderId)
        .then(response => {
          commit('SET_SURVEYS', response)
          commit(
            'SET_ADMINISTRATIVE_REMINDER_SURVEY',
            response.filter(item => item.reminder_id === 7)
          )
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSurvey({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      PhoneSurveyAnswerService.getSurvey(params.orderId, params.surveyId)
        .then(response => {
          commit('SET_SURVEY', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateAnswer({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      PhoneSurveyAnswerService.updateAnswer(payload)
        .then(response => {
          commit('UPDATE_ANSWER', {
            response: response.data,
            payload: payload
          })

          const notification = {
            type: 'success',
            message: t('store.admin.phone_survey_answer.update_answer_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey_answer.update_answer_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
